import { Stack } from '@fluentui/react';
import { PageHeader } from '@h2oai/ui-kit';

import { OAuthClientEntity } from '../../secure-store/entity/OAuthClientEntity';
import { OAuthClient } from '../../secure-store/gen/ai/h2o/securestore/v1/oauth_client_pb';
import { stackStylesNoLeftNav } from '../../themes/themes';
import { SecureStoreEntityDataContainer } from './components/SecureStoreEntityDataContainer';

const OAuthClientsPage = () => (
  <Stack styles={stackStylesNoLeftNav}>
    <PageHeader pageTitle="OAuth Clients" />

    <SecureStoreEntityDataContainer<OAuthClient> entity={OAuthClientEntity} />
  </Stack>
);

export default OAuthClientsPage;
